import { useAuth } from "@/hooks/use-auth";
import { Button } from "@/components/ui/button";
import { AlertCircle, LogOut, Mail } from "lucide-react";

export default function NoAccess() {
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="rounded-full bg-destructive/10 p-3">
            <AlertCircle className="h-12 w-12 text-destructive" />
          </div>
        </div>
        
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">
            Acesso Restrito
          </h1>
          <p className="text-muted-foreground">
            Você não possui nenhum sistema liberado para acesso.
          </p>
        </div>

        <div className="bg-muted/50 p-4 rounded-lg text-sm text-muted-foreground">
          Entre em contato com o administrador da sua empresa para solicitar acesso aos sistemas.
        </div>

        <div className="flex flex-col gap-3">
          <Button 
            variant="outline" 
            onClick={handleSignOut}
            className="w-full"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Sair da Conta
          </Button>
          
          <Button 
            variant="default"
            onClick={() => window.location.href = 'mailto:suporte@onixx.com.br?subject=Solicitação de Acesso ao Sistema'}
            className="w-full"
          >
            <Mail className="h-4 w-4 mr-2" />
            Entrar em Contato
          </Button>
        </div>
      </div>
    </div>
  );
}